// data/visionData.js
import {
  ChatIcon,
  ConnectIcon,
  RecognizeIcon,
  SupportIcon,
} from "../assets/icons";

export const visionItems = [
  {
    icon: ChatIcon,
    title: "Listen",
    description: [
      "사용자의 의사소통 경험을 깊이 이해하고, 경청하여, 각 개인의 요구에 맞는 지원을 제공합니다.",
      "이는 효과적인 의사소통 기술의 기반을 마련합니다.",
    ],
    subtitle: "경청하다",
    imageSource: require("../assets/images/listen.jpg"),
  },
  {
    icon: RecognizeIcon,
    title: "Recognize",
    description: [
      "다양한 음성과 발화 패턴을 정밀하게 인식하여, 발화의 특징을 감지하고, 의사소통 경험을 개선할 수 있는 통찰과 도구를 제공합니다.",
    ],
    subtitle: "인식하다",
    imageSource: require("../assets/images/recognize.jpg"),
  },
  {
    icon: SupportIcon,
    title: "Support",
    description: [
      "기술적 자원을 활용하여 사용자가 자신의 생각을 명확하고 자신감 있게 표현할 수 있도록 지원합니다.",
    ],
    subtitle: "지원하다",
    imageSource: require("../assets/images/support.jpg"),
  },
  {
    icon: ConnectIcon,
    title: "Connect",
    description: [
      "기술을 통해 개인들이 서로와 더 깊이 연결되고 소통할 수 있도록, 커뮤니티 내에서 의미있는 관계를 형성하고 유지할 수 있게합니다.",
    ],
    subtitle: "연결하다",
    imageSource: require("../assets/images/connect.jpg"),
  },
];
